<template>
  <nav>
    <ul>
      <li v-for="(item, index) in data" :key="index">
        <a :href="item.url" :title="item.title">{{ item.title }}</a>
      </li>
      <li class="brand" v-show="page === 'home'">
        <a href="http://file.xdf.cn/brand/brand.html">
          <img src="http://images.xdf.cn/cms20150819/zuixinban/images/brand.png" alt="">
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'Mainnav',
  props: ['page', 'data']
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
nav
  overflow: hidden
  border-bottom: 2px solid $mainNavBorderColor
  margin-bottom: 10px
  ul
    overflow: hidden
    li
      float: $fl
      a
        padding: 0 20px
        font-size: 18px
        display: block
        color: $faultcolor
        height: 40px
        line-height: 40px
      &:hover
        background: #edf6f4
        a
          color: $themeColor
    .brand
      position: absolute
      right: 0px
      top: -5px
      a
        padding: 0
      &:hover
        background: none
</style>



// WEBPACK FOOTER //
// src/common-components/Mainnav.vue